import axios from 'axios';

const service = {
    getUserInfo: async() => {
        let uri = '/users/getUser';
        let url = process.env.REACT_APP_API_URL + uri;
        let token = localStorage.getItem('token');
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }
        const consume = await axios.get(`${url}`, config)
        return consume
    }
}

export default service